import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, HostListener, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';

import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { ConfirmDeleteModalComponent } from '../../../modals/confirm-delete-modal/confirm-delete-modal.component';

import { UserService } from '../../../services/user.service';

import * as Classes from '../../../classes/models.classes';


interface MenuItem {
    icon: string;
    label: string;
    link: string;
}

@Component({
    selector: 'app-three-dots-menu',
    templateUrl: './three-dots-menu.component.html',
    styleUrls: ['./three-dots-menu.component.css']
})
export class ThreeDotsMenuComponent implements OnInit, OnDestroy, AfterViewInit  {
    @Input() Username: string;
    @Input() UserID: number;
    @Input() postUsername: string;
    @Input() postUserId: number;
    @Input() postId: number;
    @Input() isUserPost: boolean;
    @Input() userType!: string; // Logged-in user type
    @Input() postType!: string; 
    @Input() subscriptionLevel!: string; 
    @Input() pageType!: string; 

    @Output() postEditedOrDeleted: EventEmitter<void> = new EventEmitter<void>();

    //@Output() followStatusChanged = new EventEmitter<{ userId: number, isFollowed: boolean }>();

    visibleMenuItems: any[] = [];

    isDropdownOpen = false;
    isFollowed: boolean = false; // Follow status will be fetched dynamically
    isMuted: boolean = false; 
    isBlocked: boolean = false; 

    context: any; 

    menuConfig = [
        {
            id: 'editPost',
            text: () => 'Edit Post',
            conditions: [
                { postTypes: [20, 21], userTypes: ['1','2'] }, // PostType is 20 or 21 and userType is TrustLevel 1 = Super Admin, TrustLevel 2 = Admin
                { postUserId: 'loginUserId' }, // Only for the owner of the post
            ],
        },
        {
            id: 'deletePost',
            text: () => 'Delete Post',
            svg: () => this.sanitizeSvg(`
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6L5 6M10 11L14 11M10 17L14 17M10 11L10 17M14 11L14 17M8 6V4C8 3.47 8.21 2.96 8.59 2.59C8.96 2.21 9.47 2 10 2H14C14.53 2 15.04 2.21 15.41 2.59C15.79 2.96 16 3.47 16 4V6M19 6L17 18.5C17 19.33 16.33 20 15.5 20H8.5C7.67 20 7 19.33 7 18.5L5 6"></path>
                </svg>
            `),
            conditions: [
                { postUserId: 'loginUserId' }, // Only for the owner of the post
                { userTypes: ['SuperAdmin', 'Admin'] }, // For certain user types
            ],
        },
        {
            id: 'pinPost',
            text: () => 'Pin Post',
            svg: () => this.sanitizeSvg(`
                <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-1q142lx">
                    <g>
                        <path d="M17 9.76V4.5C17 3.12 15.88 2 14.5 2h-5C8.12 2 7 3.12 7 4.5v5.26L3.88 16H11v5l1 2 1-2v-5h7.12L17 9.76zM7.12 14L9 10.24V4.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5.74L16.88 14H7.12z">
                        </path>
                    </g>
                </svg>
            `),
            conditions: [
                { postUserId: 'loginUserId' }, // Only for the owner of the post
                { userTypes: ['SuperAdmin', 'Admin'] }, // For certain user types
            ],
        },
        {
            id: 'highlightPost',
            text: () => 'Highlight Post',
            svg: () => this.sanitizeSvg(`
                <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-1q142lx">
                    <g>
                        <path d="M2 4c1.66 0 3-1.34 3-3h1c0 1.66 1.34 3 3 3v1C7.34 5 6 6.34 6 8H5c0-1.66-1.34-3-3-3V4zm7.89 4.9C11.26 7.53 12 5.35 12 2h2c0 3.35.74 5.53 2.1 6.9 1.36 1.36 3.55 2.1 6.9 2.1v2c-3.35 0-5.54.74-6.9 2.1-1.36 1.37-2.1 3.55-2.1 6.9h-2c0-3.35-.74-5.53-2.11-6.9C8.53 13.74 6.35 13 3 13v-2c3.35 0 5.53-.74 6.89-2.1zm7.32 3.1c-.97-.42-1.81-.97-2.53-1.69-.71-.71-1.27-1.56-1.68-2.52-.42.96-.98 1.81-1.69 2.52-.72.72-1.56 1.27-2.53 1.69.97.42 1.81.97 2.53 1.69.71.71 1.27 1.56 1.69 2.52.41-.96.97-1.81 1.68-2.52.72-.72 1.56-1.27 2.53-1.69z">
                        </path>
                    </g>
                </svg>

            `),
            conditions: [
                { postUserId: 'loginUserId', subscriptionLevel: ['2', '3']}, // Only for elevated subscriptions
            //    { userTypes: ['SuperAdmin', 'Admin'] }, // For certain user types
            ],
        },

        {
            id: 'followUser',
            conditions: [
                { postUserId: 'loginUserId', negate: true }, // User being followed must not be the same as the current user
            ],
            text: (context: { isFollowed?: boolean; postUsername?: string } = {}) =>
                context.isFollowed && context.postUsername
                    ? `Unfollow @${context.postUsername}`
                    : `Follow @${context.postUsername || 'User'}`,
            svg: (context: { isFollowed?: boolean } = {}) =>
                context.isFollowed
                    ? this.sanitizeSvg(`
                            <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-1q142lx">
                                <g>
                                    <path d="M10 4c-1.105 0-2 .9-2 2s.895 2 2 2 2-.9 2-2-.895-2-2-2zM6 6c0-2.21 1.791-4 4-4s4 1.79 4 4-1.791 4-4 4-4-1.79-4-4zm12.586 3l-2.043-2.04 1.414-1.42L20 7.59l2.043-2.05 1.414 1.42L21.414 9l2.043 2.04-1.414 1.42L20 10.41l-2.043 2.05-1.414-1.42L18.586 9zM3.651 19h12.698c-.337-1.8-1.023-3.21-1.945-4.19C13.318 13.65 11.838 13 10 13s-3.317.65-4.404 1.81c-.922.98-1.608 2.39-1.945 4.19zm.486-5.56C5.627 11.85 7.648 11 10 11s4.373.85 5.863 2.44c1.477 1.58 2.366 3.8 2.632 6.46l.11 1.1H1.395l.11-1.1c.266-2.66 1.155-4.88 2.632-6.46z">
                                    </path>
                                </g>
                            </svg>
                        `)
                    : this.sanitizeSvg(`
                            <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-1q142lx">
                                <g>
                                    <path d="M10 4c-1.105 0-2 .9-2 2s.895 2 2 2 2-.9 2-2-.895-2-2-2zM6 6c0-2.21 1.791-4 4-4s4 1.79 4 4-1.791 4-4 4-4-1.79-4-4zm13 4v3h2v-3h3V8h-3V5h-2v3h-3v2h3zM3.651 19h12.698c-.337-1.8-1.023-3.21-1.945-4.19C13.318 13.65 11.838 13 10 13s-3.317.65-4.404 1.81c-.922.98-1.608 2.39-1.945 4.19zm.486-5.56C5.627 11.85 7.648 11 10 11s4.373.85 5.863 2.44c1.477 1.58 2.366 3.8 2.632 6.46l.11 1.1H1.395l.11-1.1c.266-2.66 1.155-4.88 2.632-6.46z">
                                    </path>
                                </g>
                            </svg>
                        `),
                    },
        {
            id: 'muteUser',
            text: (context: { postUsername: string }) =>
                `Mute @${context.postUsername}` ,
            svg: () => this.sanitizeSvg(`
                <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" class="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-lrvibr r-m6rgpd r-1nao33i r-1q142lx">
                    <g>
                        <path d="M18 6.59V1.2L8.71 7H5.5C4.12 7 3 8.12 3 9.5v5C3 15.88 4.12 17 5.5 17h2.09l-2.3 2.29 1.42 1.42 15.5-15.5-1.42-1.42L18 6.59zm-8 8V8.55l6-3.75v3.79l-6 6zM5 9.5c0-.28.22-.5.5-.5H8v6H5.5c-.28 0-.5-.22-.5-.5v-5zm6.5 9.24l1.45-1.45L16 19.2V14l2 .02v8.78l-6.5-4.06z">
                        </path>
                    </g>
                </svg>
            `),
            conditions: [
                {
                    postUserId: 'loginUserId', // User must not be the same as the current user
                    negate: true,
                    isMuted: false, // User must not be muted
                    pageType: 'profile', // Page must not be the profile page
                    negatePageType: true, // Negation for pageType
                },            ],
        },
        {
            id: 'blockUser',
            text: (context: { postUsername: string }) =>
                `Block @${context.postUsername}`,
            svg: () => this.sanitizeSvg(`
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-slash">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
                </svg>
            `),
            conditions: [
                {
                    postUserId: 'loginUserId', // User must not be the same as the current user
                    negate: true,
                    isBlocked: false, // User must not be muted
                    pageType: 'profile', // Page must not be the profile page
                    negatePageType: true, // Negation for pageType
                },            ],
        },

        {
            id: 'viewStats',
            text: () => 'View Stats',
            conditions: [
                { userTypes: ['Power User', 'Manager', 'Super Admin'] }, // For certain user types
            ],
            svg: () => (`
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-slash">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
                </svg>
            `),
        },
    ];

    constructor(
        private userService: UserService,
        private sanitizer: DomSanitizer,
        private modalService: NgbModal,

        private toastr: ToastrService

    ) {
    }

    ngOnInit(): void {
        //console.log('this.UserID:', this.UserID); // Debugging output

        this.fetchUserStatuses().then(() => {
            //console.log('this.postUsername:', this.postUsername); // Debugging output
            this.context = {
                isFollowed: this.isFollowed,
                isMuted: this.isMuted,
                isBlocked: this.isBlocked,
                postUsername: this.postUsername, 
                postUserId: this.postUserId,
                loginUserId: this.UserID,
                userType: this.userType,
                postType: this.postType,
                subscriptionLevel: this.subscriptionLevel,
                pageType: this.pageType,
            };
            //console.log('this.context:', this.context); // Debugging output

            //this.visibleMenuItems = this.menuConfig.filter((menuItem) =>
            //    this.isMenuItemVisible(menuItem.conditions, context)
            //);

            //this.visibleMenuItems = this.menuConfig.filter((menuItem) =>
            //    this.isMenuItemVisible(menuItem.conditions, this.context)
            //).filter(menuItem => typeof menuItem.svg === 'function');

            this.updateVisibleMenuItems();
        });

        // Additional initialization can be done here
        document.addEventListener('click', this.closeDropdownOnClickOutside.bind(this));

    }

    ngAfterViewInit(): void {

    }

    ngOnDestroy(): void {
        document.removeEventListener('click', this.closeDropdownOnClickOutside.bind(this));
    }

    sanitizeSvg(svgString: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(svgString);
    }

    updateVisibleMenuItems(): void {
        this.visibleMenuItems = this.menuConfig.filter((menuItem) =>
            this.isMenuItemVisible(menuItem.conditions, this.context)
        );
    }

    isMenuItemVisible(
        conditions: any[],
        context: { postUserId: number; loginUserId: number; userType: string; postType: string; subscriptionLevel: string; isMuted: boolean; isBlocked: boolean; pageType: string }
    ): boolean {
        return conditions.some((condition) => {
            // Check if postUserId matches loginUserId with negate option
            if (condition.postUserId === 'loginUserId') {
                const isSameUser = context.postUserId === context.loginUserId;
                //console.log('Checking isSameUser:', isSameUser);
                if (condition.negate && isSameUser) {
                    return false; // Condition fails if negate is true and user IDs match
                }
                if (!condition.negate && !isSameUser) {
                    return false; // Condition fails if negate is false and user IDs don't match
                }
            }

            // Check if the user is muted
            if (condition.isMuted !== undefined && condition.isMuted !== context.isMuted) {
                return false; // Condition fails if isMuted does not match
            }

            // Check if the user is blocked
            if (condition.isBlocked !== undefined && condition.isBlocked !== context.isBlocked) {
                return false; // Condition fails if isBlocked does not match
            }

            // Check the pageType with optional negation
            if (condition.pageType !== undefined) {
                const isPageMatch = condition.pageType === context.pageType;
                if (condition.negatePageType && isPageMatch) {
                    return false; // Condition fails if negatePageType is true and pageType matches
                }
                if (!condition.negatePageType && !isPageMatch) {
                    return false; // Condition fails if negatePageType is false and pageType does not match
                }
            }

            // Check if userType matches
            if (condition.userTypes && !condition.userTypes.includes(context.userType)) {
                //console.log('UserType mismatch:', context.userType);
                return false;
            }

            // Check if subscriptionLevel matches
            if (condition.subscriptionLevel && !condition.subscriptionLevel.includes(context.subscriptionLevel)) {
                //console.log('UserType subscriptionLevel:', context.subscriptionLevel);
                return false;
            }

            // Check if postType matches
            if (condition.postTypes && !condition.postTypes.includes(context.postType)) {
                return false;
            }

            return true; // If all checks pass, the condition is satisfied
        });
    }

    onMenuItemClick(menuItemId: string, event: MouseEvent): void {
        switch (menuItemId) {
            case 'editPost':
                //this.editPost();
                break;
            case 'deletePost':
                this.deletePost();
                break;
            case 'pinPost':
                this.pinPost();
                break;
            case 'highlightPost':
                this.highlightPost();
                break;
            case 'muteUser':
                this.muteUser(event);
                break;
            case 'blockUser':
                this.blockUser(event);
                break;
            case 'viewStats':
                //this.viewStats();
                break;
            case 'followUser':
                this.followUser(event); // Call followUser with the MouseEvent
                break;
            default:
                console.warn('Unhandled menu item:', menuItemId);
        }
    }


    toggleDropdown(event: MouseEvent) {
        event.stopPropagation();
        this.isDropdownOpen = !this.isDropdownOpen;

        if (this.isDropdownOpen) {
            this.fetchUserStatuses();
        }
    }

    closeDropdownOnClickOutside(event: MouseEvent) {
        if (this.isDropdownOpen && !this.isClickInsideMenu(event)) {
            this.isDropdownOpen = false;
        }
    }

    isClickInsideMenu(event: MouseEvent): boolean {
        const target = event.target as HTMLElement;
        return target.closest('.dropdown-menu') !== null || target.closest('.dropdown') !== null;
    }

    //fetchFollowStatus() {
    //    this.userService.getFollowStatus(this.UserID, this.postUserId).subscribe({
    //        next: (result) => {
    //            this.isFollowed = result.isFollowed;
    //        },
    //        error: (error) => {
    //            console.error('Error fetching follow status:', error);
    //        }
    //    });
    //}

    fetchFollowStatus(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.userService.getFollowStatus(this.UserID, this.postUserId).subscribe({
                next: (result) => {
                    this.isFollowed = result.isFollowed;
                    resolve();
                },
                error: (error) => {
                    console.error('Error fetching follow status:', error);
                    reject(error);
                },
            });
        });
    }

    fetchMuteStatus(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.userService.getMutedStatus(this.UserID, this.postUserId).subscribe({
                next: (result) => {
                    this.isMuted = result.isMuted;
                    resolve();
                },
                error: (error) => {
                    console.error('Error fetching muted status:', error);
                    reject(error);
                },
            });
        });
    }

    fetchUserStatuses(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.userService.getUserStatuses(this.UserID, this.postUserId).subscribe({
                next: (statuses: Classes.UserStatuses) => {
                    this.isFollowed = statuses.IsFollowed;
                    this.isMuted = statuses.IsMuted;
                    this.isBlocked = statuses.IsBlocked;
                    resolve();
                },
                error: (error) => {
                    console.error('Error fetching user statuses:', error);
                    reject(error);
                },
            });
        });
    }

    followUser(event: MouseEvent) {
        event.stopPropagation(); // Prevents the navigation
        this.userService.followUser(this.UserID, this.postUserId, this.isFollowed, this.isMuted, this.isBlocked).subscribe({
            next: (result) => {
                // Toggle the isFollowed status
                //this.isFollowed = !this.isFollowed;
                this.isFollowed = result;

                // Update the context
                this.context.isFollowed = this.isFollowed;

                //this.followStatusChanged.emit({ userId: this.postUserId, isFollowed: this.isFollowed });

                const message = this.isFollowed ? `${this.postUsername} followed successfully` : `${this.postUsername} unfollowed successfully`;
                this.toastr.success(message);

                // Update visible menu items
                this.updateVisibleMenuItems();
            },
            error: (error) => {
                console.error('Error following the user', error);
            }

        });
        this.isDropdownOpen = false; 
    }

    muteUser(event: MouseEvent) {
        event.stopPropagation(); // Prevents the navigation
        this.userService.muteUser(this.UserID, this.postUserId, this.isFollowed, this.isMuted, this.isBlocked).subscribe({
            next: (result) => {
                // Toggle the isFollowed status
                //this.isFollowed = !this.isFollowed;
                this.isMuted = result;

                // Update the context
                this.context.isMuted = this.isMuted;

                //this.followStatusChanged.emit({ userId: this.postUserId, isFollowed: this.isFollowed });

                const message = this.isMuted ? `${this.postUsername} muted successfully` : `${this.postUsername} unmuted successfully`;
                this.toastr.success(message);

                // Update visible menu items
                this.updateVisibleMenuItems();
            },
            error: (error) => {
                console.error('Error muting the user', error);
            }

        });
        this.isDropdownOpen = false;
    }

    blockUser(event: MouseEvent) {
        event.stopPropagation(); // Prevents the navigation
        this.userService.blockUser(this.UserID, this.postUserId, this.isFollowed, this.isMuted, this.isBlocked).subscribe({
            next: (result) => {
                // Toggle the isFollowed status
                //this.isFollowed = !this.isFollowed;
                this.isBlocked = result;

                // Update the context
                this.context.isBlocked = this.isBlocked;

                //this.followStatusChanged.emit({ userId: this.postUserId, isFollowed: this.isFollowed });

                const message = this.isBlocked ? `${this.postUsername} blocked successfully` : `${this.postUsername} unblocking successfully`;
                this.toastr.success(message);

                // Update visible menu items
                this.updateVisibleMenuItems();
            },
            error: (error) => {
                console.error('Error blocking the user', error);
            }

        });
        this.isDropdownOpen = false;
    }

    deletePost(): void {
        const modalRef = this.modalService.open(ConfirmDeleteModalComponent, { size: 'md' });
        modalRef.componentInstance.postId = this.postId;

        modalRef.componentInstance.confirm.subscribe(() => {
            modalRef.close(); // Close the modal after confirmation
            this.userService.deletePost(this.postId).subscribe({
                next: () => {
                    this.toastr.success('Post deleted successfully.', 'Success');
                    this.postEditedOrDeleted.emit(); // Emit event to refresh posts
                },
                error: (error) => {
                    //this.toastr.error(`${error.statusText}<br>Failed to delete the post.`, 'Error');
                    const errorMessage = `${error.statusText}<br>Failed to delete the post.`;
                    this.toastr.error(errorMessage, 'Error');
                    //console.error('Error deleting post:', error);
                }
            });
        });

        modalRef.componentInstance.cancel.subscribe(() => {
            modalRef.close(); // Close the modal when canceled
        });
    }

    pinPost() {
        this.userService.pinPost(this.postId).subscribe(() => {
            console.log('Post pinned');
        });
    }

    highlightPost() {
        this.userService.highlightPost(this.postId).subscribe(() => {
            console.log('Post highlighted');
        });
    }
}
